module.exports = __webpack_public_path__ + "media/timesup.cd734fd1.mp3";